import { useEffect } from 'react';

import { useGetOnboardingUserInfoQuery } from 'shared/api/onboarding';
import { eventService } from 'shared/api/event-service';
import { RealtimeService } from 'shared/lib/realtime';
import { initIntercom } from 'shared/lib/intercom';
import { AuthService } from 'shared/lib/keycloak';
import { useAppSelector } from 'shared/lib/redux';
import { useSalesforceChat } from 'shared/lib/salesforce-chat';

export const useInitializeServices = () => {
  const userBk = AuthService.getUserBk();

  const hasError = useAppSelector(
    (state) =>
      state.onboarding.queries[`getOnboardingUserInfo("${userBk}")`]?.status ===
      'rejected',
  );

  const { data: onboardingUserInfo } = useGetOnboardingUserInfoQuery(userBk, {
    skip: !userBk || hasError,
  });

  useSalesforceChat();

  useEffect(() => {
    if (!onboardingUserInfo) return;

    const initializeServices = () => {
      eventService.init(AuthService.getUserBk());
      RealtimeService.init();

      // Avoid 'await' here so Intercom can proceed with initialisation in parallel with the app load.
      initIntercom(onboardingUserInfo);
    };

    initializeServices();
  }, [onboardingUserInfo]);
};
